import React, { Component } from "react";
import Button from "./Button";

class ButtonAction extends Component {
  render() {
    const { iconName, onClick, ...rest } = this.props;
    return (
      <Button
        {...rest}
        className="btnAct background-transparent txt-site txt-title"
        type="button"
        onClick={onClick}
      >
        <i
          className={`fa ${iconName} ${
            rest.disabled ? "color-grey" : "color-red"
          }`}
        />
      </Button>
    );
  }
}
export default ButtonAction;
